/**
 * Header: Jimmy Fairly–style nav panel on menu hover (full-width below header)
 */
(function () {
  const init = () => {
    const wrapper = document.querySelector('.header-wrapper--drawer');
    if (!wrapper || window.innerWidth < 1100) return;

    const drawer = document.getElementById('desktop-drawer');
    const drawerContent = document.getElementById('drawer-content');
    const overlay = document.getElementById('drawer-overlay');
    const menuItems = Array.from(wrapper.querySelectorAll('.list-menu-item')).filter(
      (item) =>
        item.classList.contains('list-menu--submenu') ||
        item.classList.contains('list-menu--megamenu') ||
        item.querySelector('.header__submenu, burger-menu, .desktop-nav-source')
    );

    let closeTimeout = null;
    const CLOSE_DELAY = 400;

    const cloneTierGroup = (tierGroup) => {
      const clone = tierGroup.cloneNode(true);
      clone.querySelectorAll('.mega-menu__items').forEach((el) => el.remove());
      return clone;
    };

    const getTierNavHtml = (menuItem, megaMenu) => {
      const tierFromItem = menuItem.querySelector('.desktop-nav-source .mega-menu__tier-group--burger');
      if (tierFromItem) {
        return (
          '<nav class="desktop-drawer__nav" role="navigation">' +
          cloneTierGroup(tierFromItem).outerHTML +
          '</nav>'
        );
      }

      if (megaMenu) {
        const tierGroup = megaMenu.querySelector('.mega-menu__tier-group--burger');
        if (tierGroup) {
          return (
            '<nav class="desktop-drawer__nav" role="navigation">' +
            cloneTierGroup(tierGroup).outerHTML +
            '</nav>'
          );
        }

        const list = megaMenu.querySelector('.desktop-nav-source, .burger-menu__list');
        if (list) {
          return '<ul class="desktop-drawer__menu list-unstyled">' + list.innerHTML + '</ul>';
        }
      }

      return '';
    };

    const getMenuItemHtml = (menuItem) => {
      const submenu = menuItem.querySelector('.header__submenu');
      const megaMenu = menuItem.querySelector('burger-menu');
      let html = getTierNavHtml(menuItem, megaMenu);

      if (!html && submenu) {
        const collectionsClass = menuItem.classList.contains('list-menu-item--collections-nav')
          ? ' header__submenu--collections'
          : '';
        html =
          '<ul class="desktop-drawer__menu desktop-drawer__menu--tiered' +
          collectionsClass +
          ' list-unstyled" role="list">' +
          submenu.innerHTML +
          '</ul>';
      }

      return html;
    };

    const measureMaxDrawerHeight = () => {
      if (!drawer || !drawerContent || menuItems.length === 0) return;

      const measure = document.createElement('div');
      measure.style.position = 'absolute';
      measure.style.visibility = 'hidden';
      measure.style.pointerEvents = 'none';
      measure.style.top = '0';
      measure.style.left = '0';
      measure.style.width = drawerContent.offsetWidth ? `${drawerContent.offsetWidth}px` : '48rem';
      measure.style.height = 'auto';
      measure.style.overflow = 'visible';
      document.body.appendChild(measure);

      let maxHeight = 0;
      menuItems.forEach((item) => {
        const html = getMenuItemHtml(item);
        if (!html) return;
        measure.innerHTML = html;
        maxHeight = Math.max(maxHeight, measure.scrollHeight);
      });

      document.body.removeChild(measure);
      if (maxHeight) {
        drawer.style.minHeight = `${maxHeight}px`;
        drawerContent.style.minHeight = `${maxHeight}px`;
      }
    };

    const openDrawer = (menuItem) => {
      clearTimeout(closeTimeout);

      const submenu = menuItem.querySelector('.header__submenu');
      const megaMenu = menuItem.querySelector('burger-menu');

      let html = getTierNavHtml(menuItem, megaMenu);

      if (!html && submenu) {
        const collectionsClass = menuItem.classList.contains('list-menu-item--collections-nav')
          ? ' header__submenu--collections'
          : '';
        html =
          '<ul class="desktop-drawer__menu desktop-drawer__menu--tiered' +
          collectionsClass +
          ' list-unstyled" role="list">' +
          submenu.innerHTML +
          '</ul>';
      }

      if (drawerContent && html) {
        // which photo the panel shows (assets/jimmy.css)
        if (drawer) drawer.dataset.menu = menuItem.dataset.menuHandle || '';
        drawerContent.innerHTML = html;
        drawerContent.querySelectorAll('a').forEach((a) => a.classList.add('drawer-link'));
        drawer?.classList.add('is-open');
        document.body.classList.add('desktop-nav-panel-open');
      }
    };

    const closeDrawer = (delay = 0) => {
      const close = () => {
        drawer?.classList.remove('is-open');
        document.body.classList.remove('desktop-nav-panel-open');
      };
      if (delay) {
        closeTimeout = setTimeout(close, delay);
      } else {
        clearTimeout(closeTimeout);
        close();
      }
    };

    const isOverMenuItem = (el) => {
      if (!el || !el.closest) return false;
      return menuItems.some((item) => item.contains(el));
    };
    const isOverMenuOrDrawer = (el) => isOverMenuItem(el) || (drawer && drawer.contains(el));

    menuItems.forEach((item) => {
      const link = item.querySelector('.header__menu-item');
      const hasChildren =
        item.classList.contains('list-menu--submenu') ||
        item.classList.contains('list-menu--megamenu') ||
        item.querySelector('.header__submenu, burger-menu, .desktop-nav-source');

      if (!hasChildren || !link) return;

      item.addEventListener('mouseenter', () => openDrawer(item));
      item.addEventListener('mouseleave', (e) => {
        if (isOverMenuOrDrawer(e.relatedTarget)) return;
        closeDrawer(CLOSE_DELAY);
      });
    });

    if (drawer) {
      drawer.addEventListener('mouseenter', () => clearTimeout(closeTimeout));
      drawer.addEventListener('mouseleave', (e) => {
        if (isOverMenuOrDrawer(e.relatedTarget)) return;
        closeDrawer(CLOSE_DELAY);
      });
    }

    if (overlay) {
      overlay.addEventListener('click', () => closeDrawer(0));
    }

    measureMaxDrawerHeight();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1100) init();
  });
})();
